import React,{useState,useRef,useEffect} from 'react'
import { Formik, Field } from 'formik'
import axios from 'axios'
import moment from 'moment'
import DatePicker from "react-datepicker"
import Cleave from 'cleave.js/react'
import parse from 'html-react-parser'

import { Form, Input, TextArea, Button, Select, Label, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment } from 'semantic-ui-react'

import { WindowReload, WindowURL, WindowLocation, RouteURL, WindowLocationBaseUrl, ReportsDev } from '../../../../services/redirect'
import Paginations from '../../../../services/paginations'
import EntryList from '../../../../services/entries'
import Spinner from '../../../../services/spinner'
import AlertMessage from '../../../../services/alert'
import AlertConfirmation from '../../../../services/confirmation'
import { DropdownComponent } from '../../../../components/options'

import AddEmail from './add-email'
import SendEmail from './send-processed'

import AuthDenied from '../../../ErrorPage/denied'

export default function ProccessedOrdersCurrentWeek(props){

  const FormReference = useRef();

  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(true);
  const [statusSpinner,setstatusSpinner] = useState(false);
  const [spinoverlay,setspinoverlay] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
      if(data.reload){
        WindowReload();
      }
    }
  }

  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
    {intent:'info',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}}
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
      if(data.reload){
        WindowReload();
      }
    }
  }



  /*------------------------------------------------------
    ALERT CONFIRMATION
    {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
  -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
  }


  /*----------------------------------------
    LIST DATA TABLE
  -----------------------------------------*/
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }
  function handleSubmitForm(values, props){
    if(buttonclick==1){
      props.resetForm();
      TableList(pagenumber,search);
    }else{
      let value={
        name:values.name,
        email:values.email
      }
      TableList(pagenumber,value);
    }
  }
  function ReloadList(){
    let value={
      name:'',
      email:''
    }
    TableList(pagenumber,value);
  }

  const [search, setsearch]  = useState({
      name:'',
      email:'',
	});
  
  const [statusButton, setStatusButton] = useState(0);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [info, setInfo] = useState('');

  const [list, setlist] = useState([]);
	const [pagenumber, setpagenumber] = useState(1);
	const [totaldata, settotaldata] = useState(0);
	const [entry, setentry] = useState(0);
	const [entrytype, setentrytype] = useState('');

	const [paginations, setpaginations] = useState({
			paginations:[{
			listnav:[],
			pageinfo:'',
			limit_page:'',
			total_page:'',
			total_records:'',
			current_page:'',
			startPage:'',
			endPage:'',
			ellipseLeft:'',
			ellipseRight:'',
			}]
	});

	  function pagenumberfunction(page){
				TableList(page,search);
		}
		function listreload(){
				TableList(pagenumber,search);
		}
		function searchProcess(){
			  TableList(pagenumber,search);
		}
		function TableList(page,searchstr){

        setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
        setspinner(true);

				let formData = new FormData();
				formData.append('type','currentWeek');
				formData.append('search',JSON.stringify(searchstr));
				formData.append('page',page);
				axios.post('/admin/reports/processed-orders/request.php',formData)
				.then(function (response) {

						let array = response.data;
            let obj   = array.list;

						setentry(obj.entries.val);
						setentrytype(obj.entries.type);
						setlist(obj.listtable);
						setpaginations(obj.paginations);
						settotaldata(obj.paginations.paginations.total_records);

            setInfo(array.info);
            setDateFrom(array.date_from);
            setDateTo(array.date_to);
            setStatusButton(array.status);

            setspinner(false);

				})
				.catch(function (error){
          setspinner(false);
				});
	}


  function SendToMail(){
    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Sending',text:"Sending is in progress, please wait..."}});
    setspinoverlay(true);
    let formData = new FormData();
    formData.append('type','sendMail');
    axios.post('/admin/reports/send-mail/weekly/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Processed orders sent to respective email.'}});
          setnotify(true);
          setTimeout(function() {
            setnotify(false);
          },2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Send Failed',text:'Processed orders did not sent successfully.'}});
          setnotify(true);
          setTimeout(function() {
            setnotify(false);
          },2000);
        }

        setspinoverlay(false);
    })
    .catch(function (error){
      setspinoverlay(false);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
  }


  /*------------------------------------------------------
          ADD / EDIT MODAL
  -------------------------------------------------------*/
  const [isemail, setisemail] = useState(false);
  const [sendProcessed, setsendProcessed] = useState(false);
  const [dataForm, setDataForm] = useState({});

  function ClassModalBody(data){
    if(data){
      document.body.classList.add("modal");
    }else{
      document.body.classList.remove("modal");
    }
  }

  function CallbackModal(data){
    if(data.close){
      ClassModalBody(false);
      setsendProcessed(false);
      setisemail(false);
    }
    if(data.reload){
      TableList(pagenumber,search);
    }
  }





  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [orderStatus, setorderStatus] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setorderStatus(source.order_status);
  }


  /*------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  -------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('avsn5ydrg9tpjc63m');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;

        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        // Load page when view permission is granted
        if(obj.view==1){
          TableList(pagenumber,search);
          HandleOptions();
        }
        setloader(false);

    })
    .catch(function (error){
      setloader(false);
      setspinner(true);
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);
    });
 }


  useEffect(()=>{
    // Load Permission
    AuthPagesPermission();
    //TestQuery();
  },[]);

  return (
    <React.Fragment>



       {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
       {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}
       {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
       {spinoverlay&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}

       {sendProcessed&&<SendEmail callback={CallbackModal}/>}
       {isemail&&<AddEmail callback={CallbackModal}/>}
       

       {(authPages['view']==0&&!loader)&&<AuthDenied/>}
       {(authPages['view']==1&&!loader)&&<React.Fragment>


       <div className="app-page-title">
        <h1>Weekly - Proccessed Orders</h1>
       </div>
       <div className="app-body-wrapper">

       {/*---------------------------------------------------------
          SEARCH SECTION
         --------------------------------------------------------*/}
       {/*<Formik
         initialValues={search}
         onSubmit={handleSubmitForm}
         innerRef={FormReference}
         render={formProps => {
         const { values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, touched, setFieldValue } = formProps

         const CustomDateFrom = ({ value, onClick }) => (
           <Input iconPosition='left' onClick={onClick} value={values.date_order_from}><i className='uil-calender icon'></i><input /></Input>
         );
         const CustomDateTo = ({ value, onClick }) => (
           <Input iconPosition='left' onClick={onClick} value={values.date_order_to}><i className='uil-calender icon'></i><input /></Input>
         );

         return(<React.Fragment>
           <div className="search-wrapper">
              <div className="search-body">
                <Form>

                    <Form.Group widths="equal">
                        <Field name="name">
                          {({ field, form }) => (
                          <Form.Field>
                            <label>Name</label>
                            <Input fluid {...field} onChange={handleChange}/>
                          </Form.Field>
                          )}
                        </Field>
                        <Field name="email">
                            {({ field, form }) => (
                            <Form.Field>
                              <label>Email</label>
                              <Input fluid {...field} onChange={handleChange}/>
                            </Form.Field>
                            )}
                          </Field>
                    </Form.Group>
                 </Form>
              </div>
              <div className="search-footer">
                <Button type="button" icon='sync alternate' size='tiny' className="LightGrayButton" content='Reset' onClick={() => buttonSubmit(1)}/>
                <Button type="button" icon='search' size='tiny' className="GreenButton" content='Search' onClick={() => buttonSubmit(2)}/>
                <button type="button" style={{'display':'none'}} ref={buttonEl} onClick={handleSubmit}></button>
              </div>
           </div>
          </React.Fragment>)}}/>*/}


      {/*---------------------------------------------------------
          TABLE LIST SECTION
         --------------------------------------------------------*/}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {!spinner&&<React.Fragment>

      {info!=''&&<div class="alert-message left info infohasborder" style={{'margin-bottom':'10px','margin-top':'5px'}}>
        <div><i class="info circle icon"></i></div>
        <div>{parse(info)}</div>
      </div>}

      {/*statusButton==0&&<div class="alert-message left error errorhasborder" style={{'margin-bottom':'10px','margin-top':'5px'}}>
        <div><i class="info circle icon"></i></div>
        <div>Reports will automatically send every week after the working hours.</div>
      </div>*/}

      <div class="alert-message left error errorhasborder" style={{'margin-bottom':'10px','margin-top':'5px'}}>
        <div><i class="info circle icon"></i></div>
        <div>
          <p>Reports will be sent automatically every week after working hours.</p>
          <p>Kindly add the emails to which you want to send this reports.</p>
        </div>
      </div>

      <div className="tableWrapper">
       <div className="panel-table">


         <div className="panel-table-header">
           <div>
              {/*<Button disabled={list.length==0} className="BtnBasic blueIcon" size='tiny' icon='plus icon' content='SENT LOGS'/>*/}
              <Button  className="BlueButton" size='tiny' icon='plus icon' content='ADD EMAIL' onClick={()=>{ setisemail(true)}}/>
           </div>
           <div>
           {/*<Button disabled={list.length==0||statusButton==0} as="a"
            href={WindowLocationBaseUrl('/')+'api/excel/reports/weekly.php?date_from='+moment(new Date(dateFrom)).format('YYYY-MM-DD')+'&date_to='+moment(new Date(dateTo)).format('YYYY-MM-DD')}
    target="_blank"  size='tiny' className='BtnBasic greenIcon' icon='uil-file-download' content='DOWNLOAD REPORTS'/>*/}
            <Button type="button" className="LightGrayButton" size='tiny' icon='sync alternate' content='Refresh' onClick={() => ReloadList()}/>
            {ReportsDev()&&<Button disabled={list.length==0} className="green" size='tiny' icon='uil-envelope-alt icon' content='SEND TO EMAIL' onClick={()=>{ setsendProcessed(true)}}/>}
           </div>
         </div>


         <div className="panel-table-body">
         <div className="table-responsive">
         <Table celled compact='very'>
           <Table.Header>
             <Table.Row>
               <Table.HeaderCell>Account</Table.HeaderCell>
               <Table.HeaderCell>Email</Table.HeaderCell>
               <Table.HeaderCell>Name</Table.HeaderCell>
               <Table.HeaderCell>Status</Table.HeaderCell>
               <Table.HeaderCell>Country</Table.HeaderCell>
               <Table.HeaderCell style={{'background-color':'#dcfce7'}}>Total Processed</Table.HeaderCell>
             </Table.Row>
           </Table.Header>

           <Table.Body>
                 {list.length==0&&<Table.Row negative><Table.Cell  colSpan='6' textAlign="center">No record found</Table.Cell></Table.Row>}
                 {list.map(function(data, key){
                   return <Table.Row key={key} verticalAlign='top' negative={data.status==2}>
                       <Table.Cell collapsing>{data.account}</Table.Cell>
                       <Table.Cell collapsing>{data.email}</Table.Cell>
                       <Table.Cell>
                          <div className="profileTable">
                            <div><img src={data.image}/></div>
                            <div>
                                <h3>{data.fullname}</h3>
                                <p>{data.role_account}</p>
                            </div>
                          </div>
                       </Table.Cell>
                       <Table.Cell collapsing>{parse(data.status_html)}</Table.Cell>
                       <Table.Cell>{data.country}</Table.Cell>
                       <Table.Cell negative={data.no_process==0} style={{'background-color':'#dcfce7'}}>{data.no_process}</Table.Cell>
                   </Table.Row>
                 })}
             </Table.Body>
             {list.length>0&&
               <Table.Footer fullWidth>
                   <Table.Row>
                   <Table.HeaderCell colSpan='6'>
                       <div className="dash-footer"><Paginations callbackPagination={paginations} callbackPagenumber={pagenumberfunction}/></div>
                   </Table.HeaderCell>
                   </Table.Row>
               </Table.Footer>
             }
         </Table>
          </div>{/*.table-responsive*/}
         </div>{/*.panel-table-body*/}
        </div>{/*.panel-table*/}
        </div>

        </React.Fragment>}

       </div>{/*.app-body-wrapper*/}
       </React.Fragment>}
    </React.Fragment>
  )
}
